import { useEffect, useState } from "react";
import axios from "axios";

const useMyIP = () => {
    const [ip, setIp] = useState("");

    useEffect(() => {
        axios.get("https://api64.ipify.org?format=json")
            .then((res) => setIp(res.data.ip))
            .catch((error) => console.error("IP 가져오기 실패:", error));
    }, []);

    return ip;
};

export default useMyIP;
